import React from 'react';
// import '../../../../screens/user/maintain/subfolder/repairservices/RepairServices';

const ServiceCard = ({ service, onClick }) => {
  return (
    <div 
      className="service-card-item"
      onClick={() => onClick(service.title)}
    >
      <div className="service-icon-container">
        <div className="service-icon-box">
          {service.icon}
          <div className="icon-accent"></div>
        </div>
      </div>
      
      <h3 className="service-card-title">{service.title}</h3>
      <p className="service-card-description">{service.description}</p>
      
      <div className="card-hover-overlay"></div>
    </div>
  );
};

export default ServiceCard;